import api from "../api";

export const useSkipDeposit = () =>
  api.put("/user/skip-deposit").then((res) => res.data);
